import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-250" data-mp="30xq6hgeoiovu">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-251" data-mp="2w56s4h863ppz">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-252" data-mp="2r7wwgju6qhtp">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-253" data-mp="2r5kc600yfvdh">
            هل مررت بهذا من قبل؟
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-254" data-mp="2i5nl5rr3ekf9">
            إذا كانت إجابتك «نعم» عن سؤال واحد على الأقل، فـالرياضيات جاهزة™ صُممت لك.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-255" data-mp="2892deynouv7q">
            أنت تستحق طريقة أسهل
            <ArrowLeftIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:-translate-x-1" aria-hidden="true" data-id="element-256" data-mp="6i7gg3hqwpzf" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-257" data-mp="3nmp1j0wopc3a">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-258" data-mp="39p0k631tsn2z">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-259" data-mp="3emsbauunc564">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="68jq47ugegnz" />
                </span>
                <div data-id="element-261" data-mp="b7d2ty1x23n3">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-262" data-mp="3slrydy2igc06">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-263" data-mp="1fh36ik6m5gr">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}